/**
 * Watches for when a table header scrolls out of view.
 * When it does, adds a cloned header that is fixed at the top of the scrolling element.
 */
var StickyTableHeader = /** @class */ (function () {
    /**
     * Creates the instance, and begins listening for scroll events.
     * @param table The table to add sticky headers to.
     * @param fixedElement A fixed element at the top of the screen to use as an anchor, rather than the top of the screen itself.
     */
    function StickyTableHeader(table, fixedElement) {
        this.table = table;
        this.fixedElement = fixedElement;
        this.headerHeight = 0;
        if (!table.tHead) {
            throw Error("Table must have a header section.");
        }
        this.header = table.tHead;
        this.scrollParent = StickyTableHeader.getParentScrollElement(table);
        this.handleScroll = this.handleScroll.bind(this);
        this.onPossibleContentChange = this.onPossibleContentChange.bind(this);
        document.addEventListener("scroll", this.handleScroll);
        if (this.scrollParent) {
            this.scrollParent.addEventListener("scroll", this.handleScroll);
        }
        table.addEventListener("keydown", this.onPossibleContentChange);
        table.addEventListener("mouseup", this.onPossibleContentChange);
    }
    StickyTableHeader.prototype.handleScroll = function () {
        // If the grid is in an element with a scrollbar, then the header should stick to the top of that element,
        //  otherwise if there is a fixed (non scrolling) element at the top of the page, then the headers must appear below that.
        //  otherwise the headers will stick to the top of the screen.
        var fixedElement = null;
        if (!this.scrollParent && this.fixedElement && getComputedStyle(this.fixedElement).position === "fixed") {
            fixedElement = this.fixedElement;
        }
        var topBoundary = this.scrollParent ? this.scrollParent.getBoundingClientRect().top : (fixedElement ? fixedElement.getBoundingClientRect().bottom : 0);
        var tableBounds = this.table.getBoundingClientRect();
        var tbodyBounds = this.table.tBodies[this.table.tBodies.length - 1].getBoundingClientRect();
        if (tableBounds.top < topBoundary && tbodyBounds.bottom - this.headerHeight > topBoundary) {
            if (!this.headerCopy) {
                // Clone the header, and re-insert it into the table. The table will then have 2 headers.
                // The original headers position is set to "fixed" which makes it float.
                // The column widths of the floating header then need to be synchronised with the header that is still inside the table layout.
                this.headerHeight = this.header.getBoundingClientRect().height;
                this.headerCopy = this.header.cloneNode(true);
                this.table.insertBefore(this.headerCopy, this.header);
                this.header.classList.add("neo-grid-fixed-header");
                this.setColumnWidths();
            }
            this.header.style.left = tableBounds.left + "px";
            this.header.style.top = topBoundary + "px";
        }
        else {
            this.setColumnWidths(true);
            this.removeCopy();
        }
    };
    StickyTableHeader.prototype.removeCopy = function () {
        if (this.headerCopy) {
            this.header.classList.remove("neo-grid-fixed-header");
            this.table.removeChild(this.headerCopy);
            this.headerCopy = undefined;
        }
    };
    StickyTableHeader.prototype.onPossibleContentChange = function () {
        var _this = this;
        setTimeout(function () { return _this.setColumnWidths(); }, 0);
    };
    StickyTableHeader.prototype.setColumnWidths = function (isRemoving) {
        if (isRemoving === void 0) { isRemoving = false; }
        if (this.headerCopy) {
            for (var i = 0; i < this.header.rows.length; i++) {
                var originalRow = this.header.rows[i], copyRow = this.headerCopy.rows[i];
                for (var j = 0; j < originalRow.cells.length; j++) {
                    var originalCell = originalRow.cells[j], copyCell = copyRow.cells[j];
                    originalCell.style.width = isRemoving ? copyCell.style.width : window.getComputedStyle(copyCell).width;
                }
            }
        }
    };
    StickyTableHeader.prototype.dispose = function () {
        document.removeEventListener("scroll", this.handleScroll);
        if (this.scrollParent) {
            this.scrollParent.removeEventListener("scroll", this.handleScroll);
        }
        this.table.removeEventListener("keydown", this.onPossibleContentChange);
        this.table.removeEventListener("mouseup", this.onPossibleContentChange);
        this.removeCopy();
    };
    /**
     * Returns the first parent element that has a scrollbar.
     */
    StickyTableHeader.getParentScrollElement = function (element) {
        var current = element;
        while (current) {
            if ((current.style.height || current.style.maxHeight) &&
                (current.style.overflow === "scroll" || current.style.overflow === "auto" || current.style.overflowY === "scroll" || current.style.overflowY === "auto")) {
                return current;
            }
            current = current.parentElement;
        }
        return undefined;
    };
    return StickyTableHeader;
}());
export { StickyTableHeader };
